import { observer } from "mobx-react-lite";
import { FunctionComponent } from "react";

import { TextBadge, TextBadgeSize, useTheme } from "@bps/fluent-ui";
import { AppointmentStatusCode } from "@libs/gateways/booking/BookingGateway.dtos.ts";

import { getAppointmentStatusColours } from "../shared-components/appointment-status/utils.ts";
import { BookingCalendarEventProps } from "./BookingCalendarEvent.types.ts";

export const GroupAppointmentStatusBadge: FunctionComponent<BookingCalendarEventProps> =
  observer(({ event }) => {
    const calendarEvent = event.model;
    const theme = useTheme();

    let backgroundColor: string;

    if (calendarEvent.appointmentStatus === AppointmentStatusCode.Finalised) {
      const apptStatusColors = getAppointmentStatusColours(theme);
      backgroundColor = apptStatusColors(AppointmentStatusCode.Finalised).dark;
    } else {
      backgroundColor = theme.palette.neutralLighter;
    }

    let badgeDisplayText: string = "";

    if (calendarEvent.appointmentStatus === AppointmentStatusCode.Waiting) {
      const waitingStatusAttendees = calendarEvent.activeAttendees.filter(
        x => x.attendeeStatus === AppointmentStatusCode.Waiting
      ).length;

      const bookedStatusAttendees = calendarEvent.activeAttendees.length;
      badgeDisplayText = `${waitingStatusAttendees}/${bookedStatusAttendees}`;
    }

    if (calendarEvent.appointmentStatus === AppointmentStatusCode.Finalised) {
      const invoicedAttendees = calendarEvent.activeAttendees.filter(
        x => !!x.invoiceIds?.length
      ).length;

      const dnaAttendees = calendarEvent.activeAttendees.filter(
        x => x.attendeeStatus === AppointmentStatusCode.DidNotAttend
      ).length;

      const toBeInvoicedAttendees =
        calendarEvent.activeAttendees.length - dnaAttendees;

      badgeDisplayText = `${invoicedAttendees}/${toBeInvoicedAttendees}`;
    }

    return (
      <TextBadge
        badgeSize={TextBadgeSize.small}
        customColors={{ backgroundColor }}
        styles={{
          root: {
            padding: "0px 8px",
            lineHeight: "10px"
          }
        }}
      >
        {badgeDisplayText}
      </TextBadge>
    );
  });
